module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12f7f757","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/index.vue
// module id = 741
// module chunks = 2